<template>

    <loader v-if="!loaded"></loader>
    <router-view
        v-else
        @updateUsergroups="getUsergroups"
    ></router-view>

</template>

<script>

import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import Loader from "../../../components/Common/Loader";

export default {

    components: {
        Loader,
    },

    computed: {
        ...mapGetters([
            'getHrUsergroups',
        ]),
    },

    data() {
        return {
            loaded:false,
        }
    },

    methods: {
        ...mapActions([
            'setHrPermissions',
            'setHrUsergroups',
        ]),

        checkUsergroups() {
            if (this.getHrUsergroups.length === 0) {
                this.getUsergroups();
            } else {
                this.loaded = true;
            }
        },

        getUsergroups() {
            axios.get(this.route('api.v1.hr.usergroups.index'))
                .then(resp => {
                    this.setHrUsergroups(resp.data.data.usergroups);
                    this.setHrPermissions(resp.data.data.permissions);
                    this.loaded = true;
                });
        },
    },

    mounted(){
        this.checkUsergroups();
    },

    name:'HrUsergroupsLayout',

}

</script>
